import { Container, Texture } from '../../../odie';

import { DirectionId, DogBlockProps } from '../../defs/block';
import { config } from '../../defs/config';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-----------------------------------------------------------------------------
const manifest = {
  image0: 'dog/block.dog.0.png',
  image1: 'dog/block.dog.1.png',
};

/*
    dog block view
*/
export class DogBlockView extends Container {
  // fields
  //-------------------------------------------------------------------------
  private _direction!: DirectionId;
  private _sprite: FitWidthBlockSprite;
  private _textures: Texture[] = [];
  private _frame = 0;

  // properties
  //-------------------------------------------------------------------------
  public get direction(): DirectionId {
    return this._direction;
  }

  public set direction(direction: DirectionId) {
    this._direction = direction;

    // update x scale based on direction
    this._sprite.scaleX *= direction === 'right' ? 1 : -1;
  }

  public get frame() {
    return this._frame;
  }

  public set frame(value: number) {
    this._frame = value;
    const index = Math.floor(value) % this._textures.length;
    this._sprite.texture = this._textures[index];
  }

  // init
  //-------------------------------------------------------------------------
  constructor(props: DogBlockProps) {
    super();

    this._textures = [
      Texture.from(manifest.image0),
      Texture.from(manifest.image1),
    ];

    // spawn this way to let direction scale work right
    this._sprite = new FitWidthBlockSprite(manifest.image0, props);
    this.addChild(this._sprite);
    this._sprite.x = config.tile.size / 2;
    this._sprite.y = config.tile.size / 2;
    this.frame = 0;
  }

  public static assets(): string[] {
    return [manifest.image0, manifest.image1];
  }
}
